import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { contactInfo } from '../mockData';
import Logo from './Logo';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-teal-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <Logo size="md" />
              <span className="font-bold text-xl">DOLPHIN POWER</span>
            </div>
            <p className="text-emerald-100 leading-relaxed mb-4">
              Simple, honest energy for South Devon businesses. A family-run company dedicated to supporting our local community.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={scrollToTop} className="text-emerald-100 hover:text-white transition-colors">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('who-we-help')?.scrollIntoView({ behavior: 'smooth' })} className="text-emerald-100 hover:text-white transition-colors">
                  Who We Help
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('what-we-do')?.scrollIntoView({ behavior: 'smooth' })} className="text-emerald-100 hover:text-white transition-colors">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })} className="text-emerald-100 hover:text-white transition-colors">
                  About Us
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Mail className="text-emerald-400 flex-shrink-0 mt-1" size={18} />
                <a href={`mailto:${contactInfo.email}`} className="email-link-mobile text-emerald-100 hover:text-white transition-colors">
                  {contactInfo.email}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Phone className="text-emerald-400 flex-shrink-0 mt-1" size={18} />
                <a href={`tel:${contactInfo.phone}`} className="text-emerald-100 hover:text-white transition-colors">
                  {contactInfo.phone}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="text-emerald-400 flex-shrink-0 mt-1" size={18} />
                <span className="text-emerald-100">
                  {contactInfo.location}
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-teal-800 mt-12 pt-8 text-center">
          <p className="text-emerald-200">
            &copy; {currentYear} Dolphin Power. All rights reserved.
          </p>
          <p className="text-emerald-300 text-sm mt-2">
            Inspired by the coast we call home
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;